// export default CryptoFn
import JSEncript from 'jsencrypt'
import { Base64 } from 'js-base64'
import CryptoJS from 'crypto-js'

class CryptoFn {
  constructor () {
    this.publicKey = ''
    this.source = 'abcdef0123456789'
    this.keyStr = 'abcd1234abcd1234'
  }
  enBase64 (data) {
    Base64.encode(data)
  }
  deBase64 (data) {
    Base64.decode(data)
  }

  // 生成AESkey
  getAesKey () {
    let len = 16
    let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
    let maxPos = chars.length
    let keyStr = ''
    for (let i = 0; i < len; i++) {
      keyStr += chars.charAt(Math.floor(Math.random() * maxPos))
    }
    this.keyStr = keyStr
  }

  // 使用公钥加密AESkey
  publicKeyEncrypt (data) {
    let jsencrypt = new JSEncript()
    jsencrypt.setPublicKey(data)
    let keyStr = Base64.encode(this.keyStr)
    return jsencrypt.encrypt(keyStr)
  }

  // 加密
  encrypt (data) {
    // this.getAesKey()
    // let iv = CryptoJS.enc.Utf8.parse(this.source)
    let key = CryptoJS.enc.Utf8.parse(this.keyStr)
    let str = CryptoJS.enc.Utf8.parse(data)
    let encrypted = CryptoJS.AES.encrypt(str, key, {
      // iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  }

  // 解密
  decrypt (data) {
    // let iv = CryptoJS.enc.Utf8.parse(this.source)
    let key = CryptoJS.enc.Utf8.parse(this.keyStr)
    let decrypted = CryptoJS.AES.decrypt(data, key, {
      // iv: iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  }

  // 加密数据
  getEncryptData (publicKey, data) {
    this.publicKey = publicKey
    this.getAesKey()
    return {
      key: this.publicKeyEncrypt(publicKey),
      param: this.encrypt(data)
    }
  }

  // 解密数据
  getDecryptData (data) {
    return this.decrypt(data)
  }
}

export default CryptoFn
